import React, { useCallback, useEffect, useRef, useState } from "react";
import classes from './padlocksList.module.css'
import DataManager from "../../hooks/DataManager";
import ListCard from "../../components/GridList/ListCard";
import BasicTable from "../../components/Table/Table/Table";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import { useDispatch, useSelector } from 'react-redux';
import Button1 from "../../components/UI/Button/Button1";
import { Await, Link, useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import useSetCookie from "../../components/hooks/UseSetCookie";
import { serviceActions } from "../../store/service-Slice";
import SearchBar from "../SearchView/Search/SearchBar";
import { getGroups, updateLockDetails, updateGateway, updateSensor } from "../../Api Methods/Api";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import DropdownCustom from '../../components/forms/DropdownCreateGroup'
import Modal from "../../components/Modal/Modal";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import PadlocksSearchbar from "./padlocksSearchBar";
import { Button } from "primereact/button";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import SelectGroupDialog from "../../components/CustomDropDown/SelectGroupDialog";
import mixpanel from "mixpanel-browser";
import signalLost from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_lost_warning.png'
import warning from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/yellow_warn.png'
import warningRed from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/red_warn.png'

import battery100 from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/battery_100.png'
import signal0 from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_0.png'
import signal25 from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_25.png'
import signal50 from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_50.png'
import signal75 from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_75.png'
import signal100 from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/signal_100.png'


const sensorTypeDisplayName = (rawType) => {
    switch (rawType) {
        case 'SIGFOX RE:SURE': return "SigFox lite contact";
        case 'IOTA': return "SigFox industrial contact";
        case 'KNOWIO Sensor': return "Standalone NB-IOT Sensor";
        case 'Teltonika': return "BLE Sensor";
        default: return rawType ?? "";
    }
};

const PadlocksList = ({ locks, filtering, update, setUpdate, isSensors, isKeyboxes, isGateways }) => {

    console.log(locks);
    const [iglooLocks, setPadlocks] = useState(locks);
    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);
    const role = useSelector(state => state.auth.role);
    const apiData = { token, client }
    const dataManager = new DataManager();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [checkedItemsSet, setCheckedItemsSet] = useState(new Set());
    const [showMassSettings, setShowMassSettings] = useState(false)
    const [selectedMassAction, setSelectedMassAction] = useState("")
    const ModalDialog = useRef();
    const [modalTitle, setModalTitle] = useState("title")
    const [modalComponent, setModalComponent] = useState()
    const [selectAll, setSelectAll] = useState(false)
    const [filteredData, setFilteredData] = useState(locks)
    const [groupNames, setGroupNames] = useState([])
    const [selectedGroup, setSelectedGroup] = useState("")
    const [newStatus, setNewStatus] = useState("")
    const [changeBillable, setChangeBillable] = useState(false)
    const toast = useRef(null);
    const companyName = useSelector(state => state.auth.companyName);
    const canSelectRows = ((role === 'admin' || role === 'techsupport') && companyName == "EyeSpyFX");

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedOwnedByGroupFilter, setSelectedOwnedByGroupFilter] = useState([])
    const [selectedUsedByGroupFilter, setSelectedUsedByGroupFilter] = useState([])
    const [selectedBilledToGroupFilter, setSelectedBilledToGroupFilter] = useState([])
    const [selectedFilter, setSelectedFilter] = useState("")
    const [sortBy, setSortBy] = useState([])
    const [portalSiteNameFilter, setPortalSiteNameFilter] = useState("")
    const [includes, setIncludes] = useState(true)
    const [refresh, setRefresh] = useState(0)
    const [unlinkedOnly, setUnlinkedOnly] = useState(false)
    const [statusFilter, setStatusFilter] = useState("")
    const [batteryFilter, setBatteryFilter] = useState("")
    const [signalFilter, setSignalFilter] = useState("")
    const [sensorTypeFilter, setSensorTypeFilter] = useState("")

    const [showSelectBilledToDialog, setShowSelectBilledToDialog] = useState(false)
    const [showSelectOwnerDialog, setShowSelectOwnerDialog] = useState(false)
    const [showDeselect, setShowDeselect] = useState(false)
    const [showHardwareInvoiceDateDialog, setShowHardwareInvoiceDateDialog] = useState(false)
    const [showSaaSInvoiceDateDialog, setShowSaaSInvoiceDateDialog] = useState(false)
    const [selectedHardwareInvoiceDate, setSelectedHardwareInvoiceDate] = useState(null)
    const [selectedSaaSInvoiceDate, setSelectedSaaSInvoiceDate] = useState(null)

    const prevBody = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        setSelectedMassAction("")
    } 

     const massActionOptions = companyName == "EyeSpyFX" || companyName == "Knowio" ? [
        "Update billed to",
        "Update owned by",
        "Update billable",
        "Set hardware invoice date",
        "Set 1st SaaS invoice date"
    ] : []

    useEffect(() => {
        let filtered = [...locks]


        if (selectedBilledToGroupFilter.length > 0){
            if (isGateways) {
                filtered = filtered.filter(gateway => selectedBilledToGroupFilter === "__UNSET__"
                    ? !gateway.billedToName || gateway.billedToName === ""
                    : selectedBilledToGroupFilter.includes(gateway.billedToName));
            } else {
                filtered = filtered.filter(lock => selectedBilledToGroupFilter === "__UNSET__"
                    ? !lock.billedToName || lock.billedToName === ""
                    : selectedBilledToGroupFilter.includes(lock.billedToName));
            }
        }

        if (selectedOwnedByGroupFilter.length > 0){
            if (isGateways){
                filtered = filtered.filter(gateway => selectedOwnedByGroupFilter === "__UNSET__"
                    ? !gateway.ownedByName || gateway.ownedByName === ""
                    : selectedOwnedByGroupFilter.includes(gateway.ownedByName));
            } else {
                filtered = filtered.filter(lock => selectedOwnedByGroupFilter === "__UNSET__"
                    ? !lock.ownedByName || lock.ownedByName === ""
                    : selectedOwnedByGroupFilter.includes(lock.ownedByName));
            }

        }

        if (selectedUsedByGroupFilter.length > 0){
            if (isGateways){
                filtered = filtered.filter(gateway => selectedUsedByGroupFilter === "__UNSET__"
                    ? !gateway.name || gateway.name === ""
                    : selectedUsedByGroupFilter.includes(gateway.name));
            } else {
                filtered = filtered.filter(lock => selectedUsedByGroupFilter === "__UNSET__"
                    ? !lock.name || lock.name === ""
                    : selectedUsedByGroupFilter.includes(lock.name));
            }
        }

        if (sortBy.length > 0){
            if (sortBy.includes("Battery level desc")) {
                if (isGateways){
                    filtered = filtered
                        .sort((a, b) => b.battery - a.battery);
                } else {
                    filtered = filtered
                        .filter(lock => !isNaN(parseFloat(lock.battery)))
                        .sort((a, b) => parseFloat(b.battery) - parseFloat(a.battery)); // highest battery first
                }
            }

            if (sortBy.includes("Battery level asc")) {
                if (isGateways){
                    filtered = filtered
                        .sort((a, b) => a.battery - b.battery); // lowest battery first
                } else {
                    filtered = filtered
                        .filter(lock => !isNaN(parseFloat(lock.battery)))
                        .sort((a, b) => parseFloat(a.battery) - parseFloat(b.battery)); // lowest battery first
                }
            }

            if (sortBy.includes("Last read (newest -> oldest)")) {
                if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.lastSeenAt)
                        .sort((a, b) => new Date(b.lastSeenAt) - new Date(a.lastSeenAt)); // newest first
                } else {
                    filtered = filtered
                        .filter(lock => lock.batteryReadAt)
                        .sort((a, b) => new Date(b.batteryReadAt) - new Date(a.batteryReadAt)); // newest first
                }
                
            }

            if (sortBy.includes("Last seen (newest -> oldest)")) {
                if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.lastSeenAt)
                        .sort((a, b) => new Date(b.lastSeenAt) - new Date(a.lastSeenAt)); // newest first
                } else {
                    filtered = filtered
                        .filter(lock => lock.batteryReadAt)
                        .sort((a, b) => new Date(b.batteryReadAt) - new Date(a.batteryReadAt)); // newest first
                }
                
            }

            if (sortBy.includes("Last read (oldest -> newest)")) {
                 if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.lastSeenAt)
                        .sort((a, b) => new Date(a.lastSeenAt) - new Date(b.lastSeenAt)); // newest first
                } else {
                    filtered = filtered
                        .filter(lock => lock.batteryReadAt)
                        .sort((a, b) => new Date(a.batteryReadAt) - new Date(b.batteryReadAt)); // oldesr first
                }
            }

            if (sortBy.includes("Last seen (oldest -> newest)")) {
                 if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.lastSeenAt)
                        .sort((a, b) => new Date(a.lastSeenAt) - new Date(b.lastSeenAt)); // newest first
                } else {
                    filtered = filtered
                        .filter(lock => lock.batteryReadAt)
                        .sort((a, b) => new Date(a.batteryReadAt) - new Date(b.batteryReadAt)); // oldesr first
                }
            }

            if (sortBy.includes("Registered (oldest -> newest)")) {
                if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.dateAdded)
                        .sort((a, b) => new Date(a.dateAdded) - new Date(b.dateAdded)); // oldesr first
                } else {
                    filtered = filtered
                        .filter(lock => lock.registerDate)
                        .sort((a, b) => new Date(a.registerDate) - new Date(b.registerDate)); // oldesr first
                }
            }

            if (sortBy.includes("Registered (newest -> oldest)")) {
                if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.dateAdded)
                        .sort((a, b) => new Date(b.dateAdded) - new Date(a.dateAdded)); // oldesr first
                } else {
                    filtered = filtered
                        .filter(lock => lock.registerDate)
                        .sort((a, b) => new Date(b.registerDate) - new Date(a.registerDate)); // oldesr first
                }
            }

            if (sortBy.includes("Owner A-Z")) {
                if (isGateways){
                    filtered = filtered
                        .filter(lock => lock.name) // keeps only locks with a name
                        .sort((a, b) => a.name.localeCompare(b.name)); // Z → A
                } else {
                    filtered = filtered
                        .filter(lock => lock.ownedByName) // keeps only locks with a name
                        .sort((a, b) => a.ownedByName.localeCompare(b.ownedByName)); // Z → A
                }
            }

            if (sortBy.includes("Owner Z-A")) {
                if (isGateways) {
                    filtered = filtered
                        .filter(lock => lock.name) // keeps only locks with a name
                        .sort((a, b) => b.name.localeCompare(a.name)); // Z → A
                } else {
                    filtered = filtered
                        .filter(lock => lock.ownedByName) // keeps only locks with a name
                        .sort((a, b) => b.ownedByName.localeCompare(a.ownedByName)); // Z → A
                }
            }

            if (sortBy.includes("Billed to A-Z")) {
                if (isGateways) {
                    filtered = filtered
                        .filter(gateway => gateway.billedToName) // keeps only locks with a name
                        .sort((a, b) => a.billedToName.localeCompare(b.billedToName)); // Z → A
                } else {
                    filtered = filtered
                        .filter(lock => lock.billedToName) // keeps only locks with a name
                        .sort((a, b) => a.billedToName.localeCompare(b.billedToName)); // Z → A
                }
            }

            if (sortBy.includes("Billed to Z-A")) {
                if (isGateways) {
                    filtered = filtered
                        .filter(gateway => gateway.billedToName) // keeps only locks with a name
                        .sort((a, b) => b.billedToName.localeCompare(a.billedToName)); // Z → A
                } else {
                    filtered = filtered
                        .filter(lock => lock.billedToName) // keeps only locks with a name
                        .sort((a, b) => b.billedToName.localeCompare(a.billedToName)); // Z → A
                }
            }

            if (sortBy.includes("Used by A-Z")) {
                if (isGateways){
                    filtered = filtered
                        .filter(gateway => gateway.name) // keeps only locks with a name
                        .sort((a, b) => a.name.localeCompare(b.name)); // Z → A
                } else {
                    filtered = filtered
                        .filter(lock => lock.name) // keeps only locks with a name
                        .sort((a, b) => a.name.localeCompare(b.name)); // Z → A
                }
                
            }

            if (sortBy.includes("Used by Z-A")) {
                if (isGateways) {
                    filtered = filtered
                        .filter(gateway => gateway.name) // keeps only locks with a name
                        .sort((a, b) => b.name.localeCompare(a.name)); // Z → A
                } else {
                    filtered = filtered
                        .filter(lock => lock.name) // keeps only locks with a name
                        .sort((a, b) => b.name.localeCompare(a.name)); // Z → A
                }
            }
        }

        if (selectedFilter.length > 0){
            if (selectedFilter === "Billable"){
                if (isGateways) {
                    filtered = filtered.filter(gateway => gateway.billable == 1);
                } else {
                    filtered = filtered.filter(lock => lock.billable == 1);
                }
            }
            if (selectedFilter === "Not billable"){
                if (isGateways){
                    filtered = filtered.filter(gateway => gateway.billable == 0);
                } else {
                    filtered = filtered.filter(lock => lock.billable == 0);
                }
            }
        }

        if (isSensors && sensorTypeFilter && sensorTypeFilter.length > 0) {
            filtered = filtered.filter(sensor => sensorTypeDisplayName(sensor.sensorType) === sensorTypeFilter);
        }

        if (searchTerm !== ""){
            filtered = filtered.filter((item) => {
                const rawMatch = Object.values(item)
                    .some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()));
                if (rawMatch) return true;
                if (isSensors && item.sensorType) {
                    return sensorTypeDisplayName(item.sensorType).toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            });

            dataManager.setItem('padlocksSearchTerm', searchTerm)
        }

        if (isGateways) {
            dataManager.setItem('gatewaysSearchTerm', searchTerm)
            dataManager.setItem('gatewaysOwnedByFilter', selectedOwnedByGroupFilter)
            dataManager.setItem('gatewaysUsedByFilter', selectedUsedByGroupFilter)
            dataManager.setItem('gatewaysBilledToFilter', selectedBilledToGroupFilter)
            dataManager.setItem('gatewaysSelectedFilter', selectedFilter)
            dataManager.setItem('gatewaysSortBy', sortBy)
            dataManager.setItem('gatewaysPortalSiteNameFilter', portalSiteNameFilter)
            dataManager.setItem('gatewaysIncludes', includes)
            dataManager.setItem('gatewaysUnlinkedOnly', unlinkedOnly)
        }

        if (unlinkedOnly){
            filtered = filtered.filter(lock => lock.pinName == "Not Linked");
        }

        if (statusFilter.length > 0){
            if (statusFilter.includes("Online")){
                filtered = filtered.filter(gateway => gateway.status == "online")
            }
            if (statusFilter.includes("Offline")){
                filtered = filtered.filter(gateway => gateway.status == "stale")
            }
            if (statusFilter.includes("Missed check-in")){
                filtered = filtered.filter(gateway => gateway.status == "potentiallyStale")
            }
        }

        if (batteryFilter.length > 0){
            if (batteryFilter.includes("Low battery")){
                filtered = filtered.filter(gateway => gateway.battery <= 10)
            }
            if (batteryFilter.includes("Warning")){
                filtered = filtered.filter(gateway => gateway.battery < 30 && gateway.battery > 10)
            }
            if (batteryFilter.includes("Healthy")){
                filtered = filtered.filter(gateway => gateway.battery >= 30)
            }
        }

        if (signalFilter.length > 0){
            if (signalFilter.includes("Poor")){
                filtered = filtered.filter(gateway => gateway.signal <= 20)
            }
            if (signalFilter.includes("Fair")){
                filtered = filtered.filter(gateway => gateway.signal > 20 && gateway.signal <= 60)
            }
            if (signalFilter.includes("Good")){
                filtered = filtered.filter(gateway => gateway.signal > 60)
            }
        }

        setFilteredData(filtered)

        let mixpanelBody = {
            selectedOwnedByGroupFilter: selectedOwnedByGroupFilter,
            selectedUsedByGroupFilter: selectedUsedByGroupFilter,
            selectedBilledToGroupFilter: selectedBilledToGroupFilter,
            selectedFilter: selectedFilter,
            sortBy: sortBy,
            portalSiteNameFilter: portalSiteNameFilter,
            includes: includes,
            unlinkedOnly: unlinkedOnly,
            searchTerm: searchTerm
        }

        const getMPSearchEventName = () => {
            if (isKeyboxes) return "Keyboxes tab search performed";
            if (isSensors) return "Sensors tab search performed";
            if (isGateways) return "Gateways tab search performed";
            return "Padlocks tab search performed";
        };

        const timer = setTimeout(() => {
            if (prevBody.current && (JSON.stringify(mixpanelBody) !== JSON.stringify(prevBody.current))){
                mixpanel.track(getMPSearchEventName(), {
                    user: localStorage.getItem('email'),
                    body: mixpanelBody
                });
            } 
            prevBody.current = mixpanelBody;
            }, 2000);
        return () => clearTimeout(timer);
    }, [selectedOwnedByGroupFilter, selectedUsedByGroupFilter, selectedBilledToGroupFilter, selectedFilter, searchTerm, sortBy, portalSiteNameFilter, includes, refresh, unlinkedOnly, batteryFilter, signalFilter, statusFilter, sensorTypeFilter])

    const exportToExcel = () => {

        const excludeColumns = [
            "uuid", 
            "relationshipPin", 
            "ownedByGID", 
            "billedToGID",
            "deviceName"
        ]

        const columnMap = {
            key: 'Site ID',
            name: 'Used by',
            tag: "Portal site name",
            lockID: "Lock ID",
            battery: 'Battery %',
            batteryReadAt: 'Last Read',
            lockName: "Lock S/N",
            billedToName: "Billed to",
            ownedByName: "Owned by",
            pinName: "Output name",
            billable: "Billable"
        };

        const filtered = filteredData.map(item => {
            const newItem = {};
            Object.keys(item).forEach(key => {
                if (!excludeColumns.includes(key)) {
                    const newKey = columnMap[key] || key;
                    let value = item[key];

                    if (key === 'batteryReadAt' && value) {
                        value = new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
                    }

                    newItem[newKey] = value;
                }
            });
            return newItem;
        });


        const worksheet = XLSX.utils.json_to_sheet(filtered);        
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Locks');

        // Write the workbook to a binary array
        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });

        // Create a Blob with the correct MIME type for Excel
        const blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        // Save file with .xlsx extension
        saveAs(blob, `locks.xlsx`);

        mixpanel.track("Data exported to excel", {
            user: localStorage.getItem('email')
        })
    };


    const HandleUipiodOnClick = (DeviceUUID) => {
        if (DeviceUUID){
            dispatch(serviceActions.setDeviceUUID(DeviceUUID));
            navigate("/Dashboard/SiteView/" + DeviceUUID); 
        }
        useSetCookie("DeviceUUID", DeviceUUID, 1);
    }

    const HandlePadlockOnClick = (lockID) => {
        if (lockID) {
            dispatch(serviceActions.setLockID(lockID));
            navigate("/Dashboard/Padlocks/Lock/" + lockID); 
        }
        useSetCookie("LockID", lockID, 1);
    }


    const [groups, setGroups] = useState([])

    useEffect(() => {
        const GetGroups = async () => {
            const groups = await getGroups(apiData, dispatch)
            setGroups(groups)
            setGroupNames(groups.map(listOptions => listOptions.name))
        }

        GetGroups();
    }, [])

    const convertGroupIDToName = (groupID) => {
        let group = groups.find(group => group.id == groupID)
        let groupName = ""
        if (group){
            groupName = group.name
        }
        return groupName
    }
    

    const HandleGroupOnClick = (groupName) => {

        const groupClicked = groups.find(g => g.name === groupName);

        if (groupClicked) {
            sessionStorage.setItem('groupClicked', groupClicked.name)   
            sessionStorage.setItem('groupPath', groupClicked.group_path)
            sessionStorage.setItem('groupClickedID', groupClicked.id)   
            navigate("/Dashboard/Groups/GroupSites")
        }
    }

    const batteryColours = (batteryLevel) => {
        let colour = "";
        if (batteryLevel > 0 && batteryLevel < 5) {
            // red
            colour = "rgb(220,114,119)"
        } else if (batteryLevel >= 5 && batteryLevel < 20) {
            //orange
            colour = "rgb(248,183,131)"
        } else if (batteryLevel >= 20){
            //green
            colour = "rgb(101,151,100)"
        } else {
            colour = "rgba(145, 145, 145, 1)"
        }

        return colour;
    }

    const gatewayBatteryColours = (batteryLevel) => {
        let colour = "";
        if (batteryLevel > 0 && batteryLevel < 10) { //TODO change these thresholds - 30 - 100 = green, 10 - 30 orange, 0 - 10 red = GATEWAYS
            colour = "rgb(220,114,119)"
        } else if (batteryLevel >= 10 && batteryLevel < 30) {
            //orange
            colour = "rgb(248,183,131)"
        } else if (batteryLevel >= 30){
            //green
            colour = "rgb(101,151,100)"
        } else {
            colour = "rgba(145, 145, 145, 1)"
        }

        return colour;
    }

    const handleCheckboxChange = (lockID) => {
        setCheckedItemsSet(prev => {
            const newSet = new Set(prev);
            if (newSet.has(lockID)) {
                newSet.delete(lockID);
            } else {
                newSet.add(lockID);
            }
            return newSet;
        });
    };

    useEffect(() => {
        if (checkedItemsSet.size > 0) {
            setShowMassSettings(true)
            setShowDeselect(true)
        } else {
            setShowMassSettings(false)
            setShowDeselect(false)
        }
    }, [checkedItemsSet])

    const HandleDeselect = () => {
        checkedItemsSet.clear();
        setCheckedItemsSet(new Set());
    }


    // const HandleUpdateBilledTo = () => {
    //     setModalTitle("Update billed to")

    //     setModalComponent(
    //     <div>
    //         <br></br>
    //         <DropdownCustom label={"Please select a group below"} dropDownOptions={groupNames.sort((a, b) => a.localeCompare(b))} setSelectedGroup={setSelectedGroup} />
    //         <br></br>
    //         <Button1 onClick={() => massUpdateBilledTo()}>Update</Button1>
    //     </div>

    //     )
    //     HandleShowModal();
    // }

    // const HandleUpdateOwnedBy = () => {
    //     setModalTitle("Update owner")
    //     setModalComponent(
    //     <div>
    //         <br></br>
    //         <Dropdown 
    //             onChange={(e) => setSelectedGroup(e.value)} 
    //             options={groupNames.sort((a, b) => a.localeCompare(b))} 
    //             optionLabel="name" 
    //             placeholder="Select a group" 
    //             filter 
    //             className="w-full md:w-14rem" 
    //             appendTo={document.getElementById('root')}
    //         />

    //         {/* <DropdownCustom label={"Please select a group below"} dropDownOptions={groupNames.sort((a, b) => a.localeCompare(b))} setSelectedGroup={setSelectedGroup} /> */}
    //         <br></br>
    //         <Button1 onClick={() => massUpdateOwnedBy()}>Update</Button1>
    //     </div>
    //     )
    //     HandleShowModal();
    // }

    const HandleUpdateBillable = () =>{
        setChangeBillable(true)
    }

    const HandleSelectAll = () => {
        setSelectAll(!selectAll)
    }
    
    useEffect(() => {
        setCheckedItemsSet(prev => {
            const newSet = new Set(prev);
            if (selectAll){
                for (const lock of filteredData){
                    const id = isGateways ? lock.IMEI : isSensors ? (lock.clickable === 'yes' ? lock.deviceID : null) : lock.lockID;
                    if (id != null) newSet.add(id);
                }
            } else {
                newSet.clear();
            }
            return newSet;
        });
    }, [selectAll])

    useEffect(() => {
        switch (selectedMassAction) {
            case "Update billed to": {
                //HandleUpdateBilledTo()
                setShowSelectBilledToDialog(true)
                setSelectedMassAction("")
                break;
            }
            case "Update owned by": {
                //HandleUpdateOwnedBy()
                setShowSelectOwnerDialog(true)
                setSelectedMassAction("")
                break;
            }
            case "Update billable": {
                HandleUpdateBillable()
                setSelectedMassAction("")
                break;
            }
            case "Set hardware invoice date": {
                setShowHardwareInvoiceDateDialog(true)
                setSelectedMassAction("")
                break;
            }
            case "Set 1st SaaS invoice date": {
                setShowSaaSInvoiceDateDialog(true)
                setSelectedMassAction("")
                break;
            }
        }
    }, [selectedMassAction])

    const signalColours = (signal) => {
        let colour = "";
        if (signal >= 0 && signal < 25) {
            // red
            colour = "rgb(220,114,119)"
        } else if (signal >= 25 && signal < 50) {
            //orange
            colour = "rgb(248,183,131)"
        } else {
            //green
            colour = "rgb(101,151,100)"
        }

        return colour;

    }

    let signalIcons = [
        signal0,
        signal25,
        signal50, 
        signal75,
        signal100
    ]

    let keyboxTableColumns = [
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    {canSelectRows && (
                        <div style={{ marginRight: "10px" }}>
                            <Checkbox
                                onChange={e => HandleSelectAll()}
                                checked={selectAll == true}>
                            </Checkbox>
                        </div>
                    )}
                    <h3>Keybox ID</h3>
                </div>
            ),
            accessorKey: 'lockID',
            cell: (row) => (
            <div style={{ display: 'flex', alignItems: 'center', marginRight: "10px"}}>
                {canSelectRows && (
                    <CheckboxCell
                        lockID={row.row.original.lockID}
                        checked={checkedItemsSet.has(row.row.original.lockID)}
                        onChange={handleRowCheckbox(row.row.original.lockID)}
                    />
                )}
               <Link
                    to={`/Dashboard/Padlocks/Lock/${row.row.original.lockID}`}
                    className={classes.tableValueText}
                    style={{marginLeft: "10px" }}
                >
                    {row.row.original.lockID}
                </Link>
            </div>
            )
        },
        // {
        //     header: () => (
        //         <div className={classes.tableTitleText} title="Click to sort">
        //             <h3>Keybox name  </h3>
        //         </div> 
        //     ),
        //     accessorKey: 'lockName',
        //     cell: (row) => {
        //         return (
        //             <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueTextBold}>
        //                 {row.row.original.lockName || ""}
        //             </div>
        //         )
        //     }
        // },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Linked output  </h3>
                </div> 
            ),
            accessorKey: 'pinName',
            cell: (row) => {
                return (
                    <div className={classes.tableValueText}>
                        {row.row.original.pinName && row.row.original.pinName.trim() !== "Not Linked" ? (
                            <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
                                {row.row.original.pinName}
                            </div>
                        ) : <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#fa5d5dff"}
                                PillColor_IfFalse={"#fa5d5dff"}
                                text_IfTrue={"Not linked"}
                                className={classes.PillHeight}
                            /> }                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Portal site name  </h3>
                </div>  
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#919191"}
                                PillColor_IfFalse={"#6e6e6e"}
                                text_IfTrue={row.row.original.tag}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Site ID  </h3>
                </div> 
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Last known battery level</h3>
                </div> 
            ),
            accessorKey: 'battery',
            cell: (row) => {
                return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        <div style={{ position: "relative", width: 45, height: 45 }}>
                            <p style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", margin: 0, fontWeight: 600, color: "#ffffff", fontSize: 12, zIndex: 1 }}>
                                {row.row.original.battery !== 0 ? `${row.row.original.battery}%` : "?"}
                            </p>
                            <div style={{
                                width: 45,
                                height: 45,
                                backgroundColor: batteryColours(row.row.original.battery),
                                WebkitMaskImage: `url(${battery100})`,
                                WebkitMaskSize: "contain",
                                WebkitMaskRepeat: "no-repeat",
                                WebkitMaskPosition: "center",
                                maskImage: `url(${battery100})`,
                                maskSize: "contain",
                                maskRepeat: "no-repeat",
                                maskPosition: "center",
                            }} />
                        </div>
                    </div>
                )
            }
        },
        
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Date of last battery update</h3>
                </div> 
            ),
            accessorKey: 'batteryReadAt',
             meta: { style: { minWidth: "190px" } },
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.batteryReadAt)) || 
                !row.row.original.batteryReadAt 
                  ? row.row.original.batteryReadAt 
                  : format(new Date(row.row.original.batteryReadAt), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Registered  </h3>
                </div> 
            ),
            accessorKey: 'registerDate',
             meta: { style: { minWidth: "190px" } },
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.registerDate)) || 
                !row.row.original.registerDate 
                  ? row.row.original.registerDate 
                  : format(new Date(row.row.original.registerDate), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Used by</h3>
            </div> 
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a67"}
                    text_IfTrue={row.row.original.name}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Owned by</h3>
            </div> 
        ),
        accessorKey: 'ownedByName',
        cell: (row) => {
            let companyName = row.row.original.ownedByName;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.ownedByName)}>
                    <Pill_Widget
                    boolean={row.row.original.ownedByName !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.ownedByName}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Billable</h3>
                </div> 
            ),
            accessorKey: 'billable',
            cell: (row) => {
                return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        <Pill_Widget 
                        boolean={row.row.original.billable == 1} 
                        PillColor_IfTrue={"#73cf72"} 
                        PillColor_IfFalse={"#dc7277"} 
                        text_IfTrue={"Yes"}
                        text_IfFalse={"No"}
                        className={classes.PillHeight} />
                    </div>
                )
            }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Billed to</h3>
            </div> 
        ),
        accessorKey: 'billedToName',
        cell: (row) => {
            let companyName = row.row.original.billedToName;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (
                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.billedToName)}>
                    <Pill_Widget
                    boolean={row.row.original.billedToName !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.billedToName}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        }
        
    ]

    let gatewayTableColumns = [
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    {canSelectRows && (
                        <div style={{ marginRight: "10px" }}>
                            <Checkbox
                                onChange={e => HandleSelectAll()}
                                checked={selectAll == true}>
                            </Checkbox>
                        </div>
                    )}
                    <h3>IMEI</h3>
                </div>
            ),
            accessorKey: 'IMEI',
            cell: (row) => (
                <div style={{ display: 'flex', alignItems: 'center', marginRight: "10px" }}>
                    {canSelectRows && (
                        <CheckboxCell
                            lockID={row.row.original.IMEI}
                            checked={checkedItemsSet.has(row.row.original.IMEI)}
                            onChange={handleRowCheckbox(row.row.original.IMEI)}
                        />
                    )}
                    <Link
                        to={`/Dashboard/Gateways/Gateway/${row.row.original.IMEI}`}
                        className={classes.tableValueText}
                        style={{marginLeft: "10px" }}
                    >
                        {row.row.original.IMEI}
                    </Link>
                </div>
            )
        },
        
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Portal name</h3>
                </div>  
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#919191"}
                                PillColor_IfFalse={"#6e6e6e"}
                                text_IfTrue={row.row.original.tag}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        // {
        //     header: () => (
        //         <div className={classes.tableTitleText} title="Click to sort">
        //             <h3>App name</h3>
        //         </div> 
        //     ),
        //     accessorKey: 'deviceName',
        //     cell: (row) => {
        //         return (
        //             <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
        //                 {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
        //                     <Pill_Widget
        //                         boolean={true}
        //                         PillColor_IfTrue={"#C3B1E1"}
        //                         PillColor_IfFalse={"#626a67"}
        //                         text_IfTrue={row.row.original.deviceName}
        //                         className={classes.PillHeight}
        //                     />
        //                 )}                
        //             </div>
        //         )
        //     }
        // },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Site ID</h3>
                </div> 
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Last known battery level</h3>
                </div> 
            ),
            accessorKey: 'battery',
            meta: { style: { width: "90px" } },
            cell: (row) => {
                const battery = row.row.original.battery;
                const colour = gatewayBatteryColours(battery);
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        <div style={{ position: "relative", width: 45, height: 45 }}>
                            <p style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", margin: 0, fontWeight: 600, color: "#ffffff", fontSize: 12, zIndex: 1 }}>
                                {battery !== 0 ? `${battery}%` : "?"}
                            </p>
                            <div style={{
                                width: 45,
                                height: 45,
                                backgroundColor: colour,
                                WebkitMaskImage: `url(${battery100})`,
                                WebkitMaskSize: "contain",
                                WebkitMaskRepeat: "no-repeat",
                                WebkitMaskPosition: "center",
                                maskImage: `url(${battery100})`,
                                maskSize: "contain",
                                maskRepeat: "no-repeat",
                                maskPosition: "center",
                            }} />
                        </div>
                    </div>
                )
            }
        },
         {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Date of last signal</h3>
                </div> 
            ),
            accessorKey: 'lastSeenAt',
            meta: { style: { minWidth: "190px" } },
            cell: (row) => {
                const isStale = row.row.original.status == "stale"
                const formattedDate =
                isNaN(new Date(row.row.original.lastSeenAt)) ||
                !row.row.original.lastSeenAt
                  ? row.row.original.lastSeenAt
                  : format(new Date(row.row.original.lastSeenAt), "MMMM do, yyyy - HH:mm");
                return (
                  
                    <div style={{display:"flex", flexDirection:"row", gap:"5px", alignItems:"center"}}>
                        {/* {isStale && <img 
                            src={warning} 
                            style={{ width: 30, height: 30 }}  //Translate 7 to NB-IOT
                            />
                        } */}

                        <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                           <p style={{color: isStale ? "#FF0000" : "#818181"}}> {formattedDate}</p>
                        </div>
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Signal</h3>
                </div>
            ),
            accessorKey: 'signal',
            meta: { style: { width: "80px" } },
            cell: (row) => {
                const isStale = row.row.original.status == "potentiallyStale"
                const isOffline = row.row.original.status == "stale"
                const isOnline = row.row.original.status == "online"
                const signalStrength = row.row.original.signal
                const signalIcon = 
                    signalStrength >= 75 ? signal100
                    : signalStrength >= 50 ? signal75
                    : signalStrength >= 25 ? signal50
                    : signalStrength > 0  ? signal25
                    : signal0
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <div style={{ position: "relative", width: 22, height: 22 }}>
                            <img src={signalIcon} style={{ width: 22, height: 22 }} />
                            {isStale && <img src={warning} style={{ width: 22, height: 22, position: "absolute", bottom: 0, right: -2 }} />}
                            {isOffline && <img src={warningRed} style={{ width: 22, height: 22, position: "absolute", bottom: 0, right: -2 }} />}

                        </div>
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Network type</h3>
                </div> 
            ),
            accessorKey: 'serviceType',
            cell: (row) => {
                const networkType = row.row.original.serviceType == 7 ? "NB-IOT" : row.row.original.serviceType
                return (
                    <div style={{display:"flex", flexDirection:"row", gap:"5px", alignItems:"center"}}>
                        <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                            {networkType}
                        </div>
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Date added</h3>
                </div> 
            ),
            accessorKey: 'dateAdded',
            meta: { style: { minWidth: "190px" } },
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.dateAdded)) ||
                !row.row.original.dateAdded
                  ? row.row.original.dateAdded
                  : format(new Date(row.row.original.dateAdded), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Used by</h3>
            </div> 
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    <Pill_Widget
                    boolean={row.row.original.name !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.name}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Owned by</h3>
                </div> 
            ),
            accessorKey: 'ownedByName',
            cell: (row) => {
                let companyName = row.row.original.ownedByName;
    
                if (companyName == "RE:SURE") {
                    companyName = "RESURE"
                }
    
                const companyColors = {
                EyeSpyFX: "rgb(100, 149, 237)",
                RESURE: "rgb(75, 0, 130)",
                PARFAS: "rgb(0, 0, 0)",
                PORTAL_SECURITY: "rgb(0, 0, 139)",
                SOLO: "rgb(178, 34, 34)",
                KNOWIO: "rgb(20, 155, 8)",
                CPS: "rgb(8, 155, 121)",
                CSC_SECURITY: "rgb(8, 150, 155)",
                EES: "rgb(94, 8, 155)"
                };
    
                const companyColor = companyColors[companyName] || "#6e6e6e";
    
                return (
    
                    <div style={{
                        maxWidth: '100px',
                        overflow: 'hidden',
                        whiteSpace: 'normal',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        cursor: "pointer", color: "white", fontWeight: "600"
                    }} onClick={() => HandleGroupOnClick(row.row.original.ownedByName)}>
                        <Pill_Widget
                        boolean={row.row.original.ownedByName !== null}
                        PillColor_IfTrue={companyColor}
                        PillColor_IfFalse={"#626a6700"}
                        text_IfTrue={row.row.original.ownedByName}
                        className={classes.PillHeight}
                        />
                    </div>
                )
            }
            },
            {
                header: () => (
                    <div className={classes.tableTitleText} title="Click to sort">
                        <h3>Billable</h3>
                    </div> 
                ),
                accessorKey: 'billable',
                cell: (row) => {
                    return (
                        <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                            <Pill_Widget 
                            boolean={row.row.original.billable == 1} 
                            PillColor_IfTrue={"#73cf72"} 
                            PillColor_IfFalse={"#dc7277"} 
                            text_IfTrue={"Yes"}
                            text_IfFalse={"No"}
                            className={classes.PillHeight} />
                        </div>
                    )
                }
            },
            {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Billed to</h3>
                </div> 
            ),
            accessorKey: 'billedToName',
            cell: (row) => {
                let companyName = row.row.original.billedToName;
    
                if (companyName == "RE:SURE") {
                    companyName = "RESURE"
                }
    
                const companyColors = {
                EyeSpyFX: "rgb(100, 149, 237)",
                RESURE: "rgb(75, 0, 130)",
                PARFAS: "rgb(0, 0, 0)",
                PORTAL_SECURITY: "rgb(0, 0, 139)",
                SOLO: "rgb(178, 34, 34)",
                KNOWIO: "rgb(20, 155, 8)",
                CPS: "rgb(8, 155, 121)",
                CSC_SECURITY: "rgb(8, 150, 155)",
                EES: "rgb(94, 8, 155)"
                };
    
                const companyColor = companyColors[companyName] || "#6e6e6e";
    
                return (
    
                    <div style={{
                        maxWidth: '100px',
                        overflow: 'hidden',
                        whiteSpace: 'normal',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        cursor: "pointer", color: "white", fontWeight: "600"
                    }} onClick={() => HandleGroupOnClick(row.row.original.billedToName)}>
                        <Pill_Widget
                        boolean={row.row.original.billedToName !== null && row.row.original.billable == 1}
                        PillColor_IfTrue={companyColor}
                        PillColor_IfFalse={"#626a6700"}
                        text_IfTrue={row.row.original.billedToName}
                        className={classes.PillHeight}
                        />
                    </div>
                )
            }
            }
    ]

    let sensorTableColumns = [
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    {canSelectRows && (
                        <div style={{ marginRight: "10px" }}>
                            <Checkbox
                                onChange={e => HandleSelectAll()}
                                checked={selectAll == true}>
                            </Checkbox>
                        </div>
                    )}
                    <h3>Sensor ID</h3>
                </div>
            ),
            accessorKey: 'deviceID',
            cell: (row) => {
                const { deviceID, clickable } = row.row.original;
                return clickable == 'yes' ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {canSelectRows && (
                            <CheckboxCell
                                lockID={deviceID}
                                checked={checkedItemsSet.has(deviceID)}
                                onChange={handleRowCheckbox(deviceID)}
                            />
                        )}
                        <Link
                            to={`/Dashboard/Sensors/Sensor/${deviceID}`}
                            className={classes.tableValueText}
                        >
                            {deviceID}
                        </Link>
                    </div>
                ) : (
                    <div className={classes.tableValueText} style={{ paddingLeft: '28px' }}>{deviceID}</div>
                );
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Sensor name</h3>
                </div> 
            ),
            accessorKey: 'pinName',
            cell: (row) => {
                const { pinName, uuid } = row.row.original;
                return (
                    <div className={classes.tableValueText}>
                        {pinName && pinName.trim() !== "Not linked" ? (
                            <div onClick={() => HandleUipiodOnClick(uuid)} className={classes.tableValueTextBold}>
                                {pinName}
                            </div>
                        ) : (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#fa5d5dff"}
                                PillColor_IfFalse={"#fa5d5dff"}
                                text_IfTrue={"Not linked"}
                                className={classes.PillHeight}
                            />
                        )}
                    </div>
                )
            }
        },
        {
            header: () => (
              <div className={classes.tableTitleText} title="Click to sort">
                <h3>Sensor type</h3>
              </div>
            ),
            accessorKey: 'sensorType',
            cell: (row) => {

                let sensorType = "";
                switch(row.row.original.sensorType){
                    case 'SIGFOX RE:SURE':
                        sensorType = "SigFox lite contact"
                    break;
                    case 'IOTA':
                        sensorType = "SigFox industrial contact"
                    break;
                    case 'KNOWIO Sensor':
                        sensorType = "Standalone NB-IOT Sensor"
                    break;
                     case 'Teltonika':
                        sensorType = "BLE Sensor"
                    break;
                    default:
                        sensorType = row.row.original.sensorType;
                    break;
                }

              return (
                <div
                  onClick={() => HandleUipiodOnClick(row.row.original.uuid)}
                  className={classes.tableValueText}
                >
                  {sensorType}
                </div>
              );
            },
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Portal site name</h3>
                </div>  
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#919191"}
                                PillColor_IfFalse={"#6e6e6e"}
                                text_IfTrue={row.row.original.tag}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Site ID</h3>
                </div> 
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            header: () => (
              <div className={classes.tableTitleText} title="Click to sort">
                <h3>Battery level</h3>
              </div>
            ),
            accessorKey: 'battery',
            meta: { style: { width: "90px" } },
            cell: (row) => {
              const battery = row.row.original.battery;
              const hasData = battery !== "Not Read Yet" && battery !== "No Data" && battery != null;
              const colour = hasData ? gatewayBatteryColours(battery) : "#9e9e9e";
              return (
                <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                  <div style={{ position: "relative", width: 45, height: 45 }}>
                    <p style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", margin: 0, fontWeight: 600, color: "#ffffff", fontSize: 12, zIndex: 1 }}>
                      {hasData ? `${battery}%` : "?"}
                    </p>
                    <div style={{
                      width: 45,
                      height: 45,
                      backgroundColor: colour,
                      WebkitMaskImage: `url(${battery100})`,
                      WebkitMaskSize: "contain",
                      WebkitMaskRepeat: "no-repeat",
                      WebkitMaskPosition: "center",
                      maskImage: `url(${battery100})`,
                      maskSize: "contain",
                      maskRepeat: "no-repeat",
                      maskPosition: "center",
                    }} />
                  </div>
                </div>
              );
            },
          },
          {
            header: () => (
              <div className={classes.tableTitleText} title="Click to sort">
                <h3>Signal strength</h3>
              </div>
            ),
            accessorKey: 'signal',
            meta: { style: { width: "80px" } },
            cell: (row) => {
              if (row.row.original.sensorType === 'Teltonika') return null;
              const isStale = row.row.original.status === "potentiallyStale";
              const isOffline = row.row.original.status === "stale";
              const signalStrength = row.row.original.signal;
              const hasData = signalStrength !== "Not Read Yet" && signalStrength !== "No Data" && signalStrength != null;
              const signalIcon =
                !hasData ? signal0
                : signalStrength >= 75 ? signal100
                : signalStrength >= 50 ? signal75
                : signalStrength >= 25 ? signal50
                : signalStrength > 0  ? signal25
                : signal0;
              return (
                <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <div style={{ position: "relative", width: 22, height: 22 }}>
                    <img src={signalIcon} style={{ width: 22, height: 22 }} />
                    {isStale && <img src={warning} style={{ width: 22, height: 22, position: "absolute", bottom: 0, right: -2 }} />}
                    {isOffline && <img src={warningRed} style={{ width: 22, height: 22, position: "absolute", bottom: 0, right: -2 }} />}
                  </div>
                </div>
              );
            },
          },
          {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Owned by</h3>
            </div> 
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (
                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    {companyName && companyName.trim() !== "" && (
                        <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={companyColor}
                            PillColor_IfFalse={"#626a67"}
                            text_IfTrue={row.row.original.name}
                            className={classes.PillHeight}
                        />
                    )}
                </div>
            )
        }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Billable</h3>
                </div>
            ),
            accessorKey: 'billable',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.clickable == "yes" && <Pill_Widget
                            boolean={row.row.original.billable == 1}
                            PillColor_IfTrue={"#73cf72"}
                            PillColor_IfFalse={"#dc7277"}
                            text_IfTrue={"Yes"}
                            text_IfFalse={"No"}
                            className={classes.PillHeight}
                        />}
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Billed to</h3>
                </div>
            ),
            accessorKey: 'billedToName',
            cell: (row) => {
                let companyName = convertGroupIDToName(row.row.original.billedToGID);

                if (companyName == "RE:SURE") {
                    companyName = "RESURE"
                }

                const companyColors = {
                    EyeSpyFX: "rgb(100, 149, 237)",
                    RESURE: "rgb(75, 0, 130)",
                    PARFAS: "rgb(0, 0, 0)",
                    PORTAL_SECURITY: "rgb(0, 0, 139)",
                    SOLO: "rgb(178, 34, 34)",
                    KNOWIO: "rgb(20, 155, 8)",
                    CPS: "rgb(8, 155, 121)",
                    CSC_SECURITY: "rgb(8, 150, 155)",
                    EES: "rgb(94, 8, 155)"
                };

                const companyColor = companyColors[companyName] || "#6e6e6e";

                return (
                    <div style={{
                        maxWidth: '100px',
                        overflow: 'hidden',
                        whiteSpace: 'normal',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        cursor: "pointer", color: "white", fontWeight: "600"
                    }} onClick={() => HandleGroupOnClick(row.row.original.billedToGID)}>
                        <Pill_Widget
                            boolean={row.row.original.billedToGID !== null}
                            PillColor_IfTrue={companyColor}
                            PillColor_IfFalse={"#626a6700"}
                            text_IfTrue={convertGroupIDToName(row.row.original.billedToGID)}
                            className={classes.PillHeight}
                        />
                    </div>
                )
            }
        }

    ]

    const CheckboxCell = React.memo(({ lockID, checked, onChange }) => (
        <Checkbox onChange={() => onChange(lockID)} checked={checked} />
    ));
    const handleRowCheckbox = useCallback((lockID) => () => handleCheckboxChange(lockID), [handleCheckboxChange]);


    let tableColumns = [
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    {canSelectRows && (
                        <div style={{ marginRight: "10px" }}>
                            <Checkbox
                                onChange={e => HandleSelectAll()}
                                checked={selectAll == true}>
                            </Checkbox>
                        </div>
                    )}
                    <h3>Lock ID</h3>
                </div>
            ),
            accessorKey: 'lockID',
            cell: (row) => (
            <div style={{ display: 'flex', alignItems: 'center', marginRight: "10px" }}>
                {canSelectRows && (
                    <CheckboxCell
                        lockID={row.row.original.lockID}
                        checked={checkedItemsSet.has(row.row.original.lockID)}
                        onChange={handleRowCheckbox(row.row.original.lockID)}
                    />
                )}
                {/* <div style={{marginLeft: "10px" }} onClick={() => HandlePadlockOnClick(row.row.original.lockID)}>
                    {row.row.original.lockID}
                </div> */}

                {/* <Link
                    to={`/Dashboard/Padlocks/Lock/${row.row.original.lockID}`}
                    style={{
                    display: 'block',
                    maxWidth: '150px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    textDecoration: 'none',
                    color: 'inherit'
                    }}
                    className={classes.tableValueText}>
                </Link> */}

                <Link
                    to={`/Dashboard/Padlocks/Lock/${row.row.original.lockID}`}
                    className={classes.tableValueText}
                    style={{marginLeft: "10px" }}
                >
                    {row.row.original.lockID}
                </Link>
            </div>
            )
        },
        // {
        //     header: () => (
        //         <div className={classes.tableTitleText} title="Click to sort">
        //             <h3>Lock name
        //             </h3>
        //         </div> 
        //     ),
        //     accessorKey: 'lockName',
        //     cell: (row) => {
        //         return (
        //             <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
        //                 {row.row.original.lockName || ""}
        //             </div>
        //         )
        //     }
        // },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Linked output  </h3>
                </div> 
            ),
            accessorKey: 'pinName',
            cell: (row) => {
                return (
                    <div className={classes.tableValueText}>
                        {row.row.original.pinName && row.row.original.pinName.trim() !== "Not Linked" ? (
                            <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
                                {row.row.original.pinName}
                            </div>
                        ) : <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#fa5d5dff"}
                                PillColor_IfFalse={"#fa5d5dff"}
                                text_IfTrue={"Not linked"}
                                className={classes.PillHeight}
                            /> }                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Portal site name  </h3>
                </div>  
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div className={classes.tableValueText}>
                        {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#919191"}
                                PillColor_IfFalse={"#6e6e6e"}
                                text_IfTrue={row.row.original.tag}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Site ID  </h3>
                </div> 
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Last known battery level</h3>
                </div> 
            ),
            accessorKey: 'battery',
            cell: (row) => {
                return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        <div style={{ position: "relative", width: 45, height: 45 }}>
                            <p style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", margin: 0, fontWeight: 600, color: "#ffffff", fontSize: 12, zIndex: 1 }}>
                                {row.row.original.battery !== 0 ? `${row.row.original.battery}%` : "?"}
                            </p>
                            <div style={{
                                width: 45,
                                height: 45,
                                backgroundColor: batteryColours(row.row.original.battery),
                                WebkitMaskImage: `url(${battery100})`,
                                WebkitMaskSize: "contain",
                                WebkitMaskRepeat: "no-repeat",
                                WebkitMaskPosition: "center",
                                maskImage: `url(${battery100})`,
                                maskSize: "contain",
                                maskRepeat: "no-repeat",
                                maskPosition: "center",
                            }} />
                        </div>
                    </div>
                )
            }
        },
       
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Date of last battery update</h3>
                </div> 
            ),
            accessorKey: 'batteryReadAt',
             meta: { style: { minWidth: "190px" } },
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.batteryReadAt)) || 
                !row.row.original.batteryReadAt 
                  ? row.row.original.batteryReadAt 
                  : format(new Date(row.row.original.batteryReadAt), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
         {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Registered  </h3>
                </div> 
            ),
            accessorKey: 'registerDate',
             meta: { style: { minWidth: "190px" } },
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.registerDate)) || 
                !row.row.original.registerDate 
                  ? row.row.original.registerDate 
                  : format(new Date(row.row.original.registerDate), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Used by</h3>
            </div> 
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    <Pill_Widget
                    boolean={row.row.original.name !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.name}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Owned by</h3>
            </div> 
        ),
        accessorKey: 'ownedByName',
        cell: (row) => {
            let companyName = row.row.original.ownedByName;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.ownedByName)}>
                    <Pill_Widget
                    boolean={row.row.original.ownedByName !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.ownedByName}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Billable</h3>
                </div> 
            ),
            accessorKey: 'billable',
            cell: (row) => {
                return (
                    <div onClick={() => HandlePadlockOnClick(row.row.original.lockID)} className={classes.tableValueText}>
                        <Pill_Widget 
                        boolean={row.row.original.billable == 1} 
                        PillColor_IfTrue={"#73cf72"} 
                        PillColor_IfFalse={"#dc7277"} 
                        text_IfTrue={"Yes"}
                        text_IfFalse={"No"}
                        className={classes.PillHeight} />
                    </div>
                )
            }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Billed to</h3>
            </div> 
        ),
        accessorKey: 'billedToName',
        cell: (row) => {
            let companyName = row.row.original.billedToName;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.billedToName)}>
                    <Pill_Widget
                    boolean={row.row.original.billedToName !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.billedToName}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        }
    ]


    if (isSensors) {
        tableColumns = sensorTableColumns
    };

    if (isGateways){
        tableColumns = gatewayTableColumns
    }

    if (isKeyboxes) {
        tableColumns = keyboxTableColumns
    }

    const accept = async () => {
        isSensors ? massUpdateSensorBillable("1") : isGateways ? massUpdateGatewayBillable("1") : massUpdateBillable("1");
    }

    const reject = () => {
        isSensors ? massUpdateSensorBillable("0") : isGateways ? massUpdateGatewayBillable("0") : massUpdateBillable("0");
    }

    const UpdateLockDetails = async (lockID, columnName, newValue) => {
        let body = {
            lockID: lockID,
            columnName: columnName,
            newValue: newValue
        }
        const response = await updateLockDetails(apiData, body, dispatch)
    }

    const UpdateGatewayDetails = async (IMEI, columnName, newValue) => {
        let body = {
            gatewayIMEI: IMEI,
            columnName: columnName,
            newValue: newValue
        }
        const response = await updateGateway(apiData, body, dispatch)
    }

    const UpdateSensorDetails = async (sensorID, columnName, newValue) => {
        let body = {
            sensorID: sensorID,
            columnName: columnName,
            newValue: newValue
        }
        const response = await updateSensor(apiData, body, dispatch)
    }

    const updateAndNotify = (successfulLockIDs, columnName, newValue, message) => {
        setFilteredData(prevFilteredData =>
            prevFilteredData.map(lock =>
                successfulLockIDs.includes(lock.lockID)
                    ? { ...lock, [columnName]: newValue }
                    : lock
            )
        );

        const allSuccessful = successfulLockIDs.length === checkedItemsSet.size;

        if (allSuccessful) {
            toast.current.show({
                severity: 'success',
                summary: 'Confirmed',
                detail: message,
                life: 3000
            });
        } else {
            toast.current.show({
                severity: 'warn',
                summary: 'Partial failure',
                detail: `Some updates failed, please try again`,
                life: 4000
            });
        }
    }

    const massUpdateBillable = async (newStatus) => {
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (lockID) => {
                try {
                    await UpdateLockDetails(lockID, 'billable', newStatus);
                    return { lockID, success: true };
                } catch (error) {
                    return { lockID, success: false, error };
                }
            })
        );

        const successfulLockIDs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.lockID);

        updateAndNotify(successfulLockIDs, "billable", newStatus, "Billing status updated")
    }

    const massUpdateOwnedBy = async (value) => {
        //HandleCloseModal();
        const groupObj = groups.find(g => g.name === value);
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (lockID) => {
                try {
                    await  UpdateLockDetails(lockID, 'ownedByGID', groupObj.id)
                    return { lockID, success: true };
                } catch (error) {
                    return { lockID, success: false, error };
                }
            })
        );

        const successfulLockIDs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.lockID);

        updateAndNotify(successfulLockIDs, "ownedByName", value, "Owner updated")
    }

    const massUpdateBilledTo = async (value) => {
        const isNotSet = value === "NOT SET";
        const groupID = isNotSet ? null : groups.find(g => g.name === value)?.id;
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (lockID) => {
                try {
                    await UpdateLockDetails(lockID, 'billedToGID', groupID)
                    return { lockID, success: true };
                } catch (error) {
                    return { lockID, success: false, error };
                }
            })
        );

        const successfulLockIDs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.lockID);

        updateAndNotify(successfulLockIDs, "billedToName", isNotSet ? null : value, "Billable updated")
    }

    const updateAndNotifyGateway = (successfulIMEIs, columnName, newValue, message) => {
        setFilteredData(prevFilteredData =>
            prevFilteredData.map(gw =>
                successfulIMEIs.includes(gw.IMEI)
                    ? { ...gw, [columnName]: newValue }
                    : gw
            )
        );

        const allSuccessful = successfulIMEIs.length === checkedItemsSet.size;

        if (allSuccessful) {
            toast.current.show({ severity: 'success', summary: 'Confirmed', detail: message, life: 3000 });
        } else {
            toast.current.show({ severity: 'warn', summary: 'Partial failure', detail: `Some updates failed, please try again`, life: 4000 });
        }
    }

    const massUpdateGatewayBillable = async (newStatus) => {
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (IMEI) => {
                try {
                    await UpdateGatewayDetails(IMEI, 'billable', newStatus);
                    return { IMEI, success: true };
                } catch (error) {
                    return { IMEI, success: false, error };
                }
            })
        );

        const successfulIMEIs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.IMEI);

        updateAndNotifyGateway(successfulIMEIs, "billable", newStatus, "Billing status updated")
    }

    const massUpdateGatewayOwnedBy = async (value) => {
        const groupObj = groups.find(g => g.name === value);
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (IMEI) => {
                try {
                    await UpdateGatewayDetails(IMEI, 'ownedByGID', groupObj.id)
                    return { IMEI, success: true };
                } catch (error) {
                    return { IMEI, success: false, error };
                }
            })
        );

        const successfulIMEIs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.IMEI);

        updateAndNotifyGateway(successfulIMEIs, "ownedByName", value, "Owner updated")
    }

    const massUpdateGatewayBilledTo = async (value) => {
        const isNotSet = value === "NOT SET";
        const groupID = isNotSet ? null : groups.find(g => g.name === value)?.id;
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (IMEI) => {
                try {
                    await UpdateGatewayDetails(IMEI, 'billedToGID', groupID)
                    return { IMEI, success: true };
                } catch (error) {
                    return { IMEI, success: false, error };
                }
            })
        );

        const successfulIMEIs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.IMEI);

        updateAndNotifyGateway(successfulIMEIs, "billedToName", isNotSet ? null : value, "Billed to updated")
    }

    const updateAndNotifySensor = (successfulIDs, columnName, newValue, message) => {
        setFilteredData(prevFilteredData =>
            prevFilteredData.map(sensor =>
                successfulIDs.includes(sensor.deviceID)
                    ? { ...sensor, [columnName]: newValue }
                    : sensor
            )
        );
        const allSuccessful = successfulIDs.length === checkedItemsSet.size;
        if (allSuccessful) {
            toast.current.show({ severity: 'success', summary: 'Confirmed', detail: message, life: 3000 });
        } else {
            toast.current.show({ severity: 'warn', summary: 'Partial failure', detail: 'Some updates failed, please try again', life: 4000 });
        }
    }

    const massUpdateSensorBillable = async (newStatus) => {
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (sensorID) => {
                try {
                    await UpdateSensorDetails(sensorID, 'billable', newStatus);
                    return { sensorID, success: true };
                } catch (error) {
                    return { sensorID, success: false, error };
                }
            })
        );
        const successfulIDs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.sensorID);
        updateAndNotifySensor(successfulIDs, "billable", newStatus, "Billing status updated");
    }

    const massUpdateSensorOwnedBy = async (value) => {
        const groupObj = groups.find(g => g.name === value);
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (sensorID) => {
                try {
                    await UpdateSensorDetails(sensorID, 'ownedByGID', groupObj.id);
                    return { sensorID, success: true };
                } catch (error) {
                    return { sensorID, success: false, error };
                }
            })
        );
        const successfulIDs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.sensorID);
        updateAndNotifySensor(successfulIDs, "ownedByName", value, "Owner updated");
    }

    const massUpdateSensorBilledTo = async (value) => {
        const isNotSet = value === "NOT SET";
        const groupID = isNotSet ? null : groups.find(g => g.name === value)?.id;
        const results = await Promise.allSettled(
            Array.from(checkedItemsSet).map(async (sensorID) => {
                try {
                    await UpdateSensorDetails(sensorID, 'billedToGID', groupID);
                    return { sensorID, success: true };
                } catch (error) {
                    return { sensorID, success: false, error };
                }
            })
        );
        const successfulIDs = results
            .filter(r => r.status === 'fulfilled' && r.value.success)
            .map(r => r.value.sensorID);
        updateAndNotifySensor(successfulIDs, "billedToGID", groupID, "Billed to updated");
    }

    const massUpdateHardwareInvoiceDate = async (date) => {
        const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
        if (isSensors) {
            const results = await Promise.allSettled(
                Array.from(checkedItemsSet).map(async (sensorID) => {
                    try { await UpdateSensorDetails(sensorID, 'firstInvoiceDate', formattedDate); return { sensorID, success: true }; }
                    catch (error) { return { sensorID, success: false, error }; }
                })
            );
            const successfulIDs = results.filter(r => r.status === 'fulfilled' && r.value.success).map(r => r.value.sensorID);
            updateAndNotifySensor(successfulIDs, "firstInvoiceDate", formattedDate, "Hardware invoice date updated");
        } else if (isGateways) {
            const results = await Promise.allSettled(
                Array.from(checkedItemsSet).map(async (IMEI) => {
                    try { await UpdateGatewayDetails(IMEI, 'firstInvoiceDate', formattedDate); return { IMEI, success: true }; }
                    catch (error) { return { IMEI, success: false, error }; }
                })
            );
            const successfulIMEIs = results.filter(r => r.status === 'fulfilled' && r.value.success).map(r => r.value.IMEI);
            updateAndNotifyGateway(successfulIMEIs, "firstInvoiceDate", formattedDate, "Hardware invoice date updated");
        } else {
            const results = await Promise.allSettled(
                Array.from(checkedItemsSet).map(async (lockID) => {
                    try { await UpdateLockDetails(lockID, 'firstInvoiceDate', formattedDate); return { lockID, success: true }; }
                    catch (error) { return { lockID, success: false, error }; }
                })
            );
            const successfulLockIDs = results.filter(r => r.status === 'fulfilled' && r.value.success).map(r => r.value.lockID);
            updateAndNotify(successfulLockIDs, "firstInvoiceDate", formattedDate, "Hardware invoice date updated");
        }
        setShowHardwareInvoiceDateDialog(false);
        setSelectedHardwareInvoiceDate(null);
    }

    const massUpdateSaaSInvoiceDate = async (date) => {
        const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
        if (isSensors) {
            const results = await Promise.allSettled(
                Array.from(checkedItemsSet).map(async (sensorID) => {
                    try { await UpdateSensorDetails(sensorID, 'lastInvoiceDate', formattedDate); return { sensorID, success: true }; }
                    catch (error) { return { sensorID, success: false, error }; }
                })
            );
            const successfulIDs = results.filter(r => r.status === 'fulfilled' && r.value.success).map(r => r.value.sensorID);
            updateAndNotifySensor(successfulIDs, "lastInvoiceDate", formattedDate, "1st SaaS invoice date updated");
        } else if (isGateways) {
            const results = await Promise.allSettled(
                Array.from(checkedItemsSet).map(async (IMEI) => {
                    try { await UpdateGatewayDetails(IMEI, 'lastInvoiceDate', formattedDate); return { IMEI, success: true }; }
                    catch (error) { return { IMEI, success: false, error }; }
                })
            );
            const successfulIMEIs = results.filter(r => r.status === 'fulfilled' && r.value.success).map(r => r.value.IMEI);
            updateAndNotifyGateway(successfulIMEIs, "lastInvoiceDate", formattedDate, "1st SaaS invoice date updated");
        } else {
            const results = await Promise.allSettled(
                Array.from(checkedItemsSet).map(async (lockID) => {
                    try { await UpdateLockDetails(lockID, 'lastInvoiceDate', formattedDate); return { lockID, success: true }; }
                    catch (error) { return { lockID, success: false, error }; }
                })
            );
            const successfulLockIDs = results.filter(r => r.status === 'fulfilled' && r.value.success).map(r => r.value.lockID);
            updateAndNotify(successfulLockIDs, "lastInvoiceDate", formattedDate, "1st SaaS invoice date updated");
        }
        setShowSaaSInvoiceDateDialog(false);
        setSelectedSaaSInvoiceDate(null);
    }

   

    const defaultConfirmProps = {
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Billable',
        rejectLabel: 'Not billable',
        defaultFocus: 'accept',
        accept,
        reject,
    };

    useEffect(() => {
        setFilteredData(locks.filter((item) => {
            const rawMatch = Object.values(item)
                .some(value => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()));
            if (rawMatch) return true;
            if (isSensors && item.sensorType) {
                return sensorTypeDisplayName(item.sensorType).toLowerCase().includes(searchTerm.toLowerCase());
            }
            return false;
        }));
    }, [searchTerm])

    return (
        <>
        <Toast ref={toast} />

        <Modal ref={ModalDialog} title={modalTitle} modalName={"Update"} HandleShowModal={HandleShowModal}>
            {modalComponent}
        </Modal>

        {showSelectBilledToDialog && (
            <SelectGroupDialog
                title = {"Select the group to be billed"}
                visible={showSelectBilledToDialog}
                onHide={() => setShowSelectBilledToDialog(false)}
                groupNames={["NOT SET", ...groupNames]}
                functionToCall={(selectedGroup) => {
                    isSensors ? massUpdateSensorBilledTo(selectedGroup) : isGateways ? massUpdateGatewayBilledTo(selectedGroup) : massUpdateBilledTo(selectedGroup);
                }}
            />
        )}

        {showSelectOwnerDialog && (
            <SelectGroupDialog
                title = {"Select the new owner"}
                visible={showSelectOwnerDialog}
                onHide={() => setShowSelectOwnerDialog(false)}
                groupNames={groupNames}
                functionToCall={(selectedGroup) => {
                    isSensors ? massUpdateSensorOwnedBy(selectedGroup) : isGateways ? massUpdateGatewayOwnedBy(selectedGroup) : massUpdateOwnedBy(selectedGroup);
                }}
            />
        )}

        <ConfirmDialog
                visible={changeBillable}
                onHide={() => setChangeBillable(false)}
                {...defaultConfirmProps}
                message={`Update ${isSensors ? 'sensor' : isGateways ? 'gateway' : 'padlock'} billing status to:`}
        />

        <Dialog
            header="Set hardware invoice date"
            visible={showHardwareInvoiceDateDialog}
            style={{ width: "360px" }}
            onHide={() => { setShowHardwareInvoiceDateDialog(false); setSelectedHardwareInvoiceDate(null); }}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <Calendar
                    value={selectedHardwareInvoiceDate}
                    onChange={e => setSelectedHardwareInvoiceDate(e.value)}
                    dateFormat="dd/mm/yy"
                    showIcon
                    placeholder="Select date"
                    style={{ width: "100%" }}
                />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                    <Button icon="pi pi-times" label="Cancel" severity="secondary" onClick={() => { setShowHardwareInvoiceDateDialog(false); setSelectedHardwareInvoiceDate(null); }} />
                    <Button icon="pi pi-save" label="Apply to selected" disabled={!selectedHardwareInvoiceDate} onClick={() => massUpdateHardwareInvoiceDate(selectedHardwareInvoiceDate)} />
                </div>
            </div>
        </Dialog>

        <Dialog
            header="Set 1st SaaS invoice date"
            visible={showSaaSInvoiceDateDialog}
            style={{ width: "360px" }}
            onHide={() => { setShowSaaSInvoiceDateDialog(false); setSelectedSaaSInvoiceDate(null); }}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <Calendar
                    value={selectedSaaSInvoiceDate}
                    onChange={e => setSelectedSaaSInvoiceDate(e.value)}
                    dateFormat="dd/mm/yy"
                    showIcon
                    placeholder="Select date"
                    style={{ width: "100%" }}
                />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                    <Button icon="pi pi-times" label="Cancel" severity="secondary" onClick={() => { setShowSaaSInvoiceDateDialog(false); setSelectedSaaSInvoiceDate(null); }} />
                    <Button icon="pi pi-save" label="Apply to selected" disabled={!selectedSaaSInvoiceDate} onClick={() => massUpdateSaaSInvoiceDate(selectedSaaSInvoiceDate)} />
                </div>
            </div>
        </Dialog>
    
        <div  className={
    isGateways
      ? `${classes.tableNoBorder} ${classes.center}`
      : `${classes.table} ${classes.center}`
  }>
            <ListCard secondaryClassName={classes["Card-container"]}>
                <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "5px 10px 0px 10px" }}>
                    <Await resolve={locks}>
                        {(loadedtableData) => {
                            return (
                                <>
                                    {/* Search bar */}
                                    <div className={classes.searchContainer}>
                                        {/* <SearchBar
                                            type="text"
                                            placeholder="Search..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            style={{
                                                
                                                padding: "5px 8px", // Adjust padding to reduce height
                                                width: "300px",    // Set a specific width
                                                fontSize: "14px",  // Adjust font size for better proportions
                                                boxSizing: "border-box", // Ensure consistent sizing
                                                borderRadius: "4px", // Add slight rounding for aesthetics
                                                border: "1px solid #ccc" // Define a subtle border
                                            }}
                                        />
                                     */}

                                     {/* <div>
                                                                                <Button onClick={() => exportToExcel(filteredData, "filteredLocks")}>Export to Excel</Button>

                                     </div> */}

                                     <PadlocksSearchbar
                                        type="text"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        showFilterButton={true}
                                        groups={groups}
                                        selectedOwnedByGroupFilter={selectedOwnedByGroupFilter}
                                        setSelectedOwnedByGroupFilter={setSelectedOwnedByGroupFilter}
                                        selectedUsedByGroupFilter={selectedUsedByGroupFilter}
                                        setSelectedUsedByGroupFilter={setSelectedUsedByGroupFilter}
                                        selectedBilledToGroupFilter={selectedBilledToGroupFilter}
                                        setSelectedBilledToGroupFilter={setSelectedBilledToGroupFilter}
                                        selectedFilter={selectedFilter}
                                        setSelectedFilter={setSelectedFilter}
                                        sortBy={sortBy}
                                        setSortBy={setSortBy}
                                        portalSiteNameFilter={portalSiteNameFilter}
                                        setPortalSiteNameFilter={setPortalSiteNameFilter}
                                        includes={includes}
                                        setIncludes={setIncludes}
                                        style={{
                                            padding: "10px", 
                                            width: "300px",    
                                            fontSize: "14px",  
                                            boxSizing: "border-box", 
                                            borderRadius: "4px",
                                        }}
                                        handleExport={exportToExcel}
                                        unlinkedOnly={unlinkedOnly}
                                        setUnlinkedOnly={setUnlinkedOnly}
                                        isGateways={isGateways}
                                        isSensors={isSensors}
                                        setBatteryFilter={setBatteryFilter}
                                        setSignalFilter={setSignalFilter}
                                        setStatusFilter={setStatusFilter}
                                        sensorTypeFilter={sensorTypeFilter}
                                        setSensorTypeFilter={setSensorTypeFilter}
                                        />

                                        <p style={{ marginLeft: "15px", marginBottom: 0 }}>
                                            Total results: {filteredData.length}
                                        </p>

                                        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                                            {showMassSettings && (
                                                <Dropdown
                                                value={selectedMassAction}
                                                onChange={(e) => setSelectedMassAction(e.value)}
                                                options={massActionOptions}
                                                placeholder="Select an action"
                                                className="w-full md:w-14rem"
                                                />
                                            )}

                                            {showDeselect && (
                                                <Button
                                                severity="danger"
                                                style={{ marginTop: 0 }}
                                                label={`Deselect ${checkedItemsSet.size} items`}
                                                icon="pi pi-times"
                                                outlined
                                                onClick={HandleDeselect}
                                                />
                                            )}
                                            </div>
                                    </div>
                                    
                                
                                    {/* Table */}
                                    <BasicTable
                                        data={filteredData}
                                        columns={tableColumns}
                                        filtering={filtering}
                                        rowClick={false}
                                        ShowPagination={false}
                                        PageSize={5000}
                                        paginationOptions={[25, 50, 100]}
                                        showFilterButton={false}
                                        isSortable={false}
                                    />
                                </>
                            );
                        }}
                    </Await>
                </div>
            </ListCard>
        </div>
        </>
    );
}

export default PadlocksList;